import React, { useEffect, useState } from "react";
import { TrendingUp } from "lucide-react";
import { fetchLocalDemand } from "@/lib/api";

// Anonymous counts of "Yeh service chahiye" requests near the vendor (last 30 days).
export function LocalDemandCard() {
  const [data, setData] = useState(null);
  useEffect(() => { fetchLocalDemand().then(setData).catch(() => setData({ items: [] })); }, []);
  if (!data) return null;
  return (
    <div className="bg-white border border-slate-100 rounded-2xl p-4 sm:p-5 mb-6 min-w-0" data-testid="local-demand-card">
      <div className="flex items-center gap-2">
        <TrendingUp className="w-4 h-4 text-emerald-700" />
        <h3 className="font-display text-lg font-bold">Local demand</h3>
      </div>
      <p className="text-xs text-slate-500 mt-0.5">Aapke PIN aur {data.radius_km || 10} km ke andar log yeh dhoondh rahe hain (pichhle {data.window_days || 30} din). Naye service ka idea!</p>
      {data.items?.length ? (
        <ul className="mt-3 flex flex-wrap gap-2" data-testid="local-demand-list">
          {data.items.map((it) => (
            <li key={it.term} className="rounded-full border border-amber-200 bg-amber-50 text-amber-900 px-3 py-1.5 text-xs min-w-0 max-w-full truncate" data-testid={`local-demand-${it.term.toLowerCase().replace(/\s+/g, "-")}`}>
              <b className="font-semibold">{it.term}</b> — {it.count} {it.count === 1 ? "vyakti" : "log"} · {it.nearest_km === 0 ? "aapka PIN" : `~${it.nearest_km} km`}
            </li>
          ))}
        </ul>
      ) : (
        <div className="text-xs text-slate-400 mt-3" data-testid="local-demand-empty">Abhi aas-paas koi nayi demand nahi hai.</div>
      )}
    </div>
  );
}
